import React from "react";

// X (formerly Twitter)
function XIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  );
}
function InstagramIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="2" width="20" height="20" rx="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
    </svg>
  );
}
function TelegramIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.24 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/>
    </svg>
  );
}

export default function Footer() {
  const socials = [
    { href: "https://x.com/ZehraTanbuga",                        label: "X",          Icon: XIcon,         hoverCls: "hover:text-text-primary",  testId: "footer-x" },
    { href: "https://instagram.com/ztan_technical_analyst",      label: "Instagram",  Icon: InstagramIcon, hoverCls: "hover:text-signal-down",   testId: "footer-instagram" },
    { href: "https://t.me/ZTANTechnicalAnalyst",                 label: "Telegram",   Icon: TelegramIcon,  hoverCls: "hover:text-brand-blueLight", testId: "footer-telegram", title: "ZTAN Technical Analyst — Ücretsiz Telegram kanalımıza katılabilirsiniz" },
    { href: "https://x.com/ZehraTanbuga",                        label: "Telegram VIP", Icon: TelegramIcon, hoverCls: "hover:text-accent-yellow", testId: "footer-telegram-vip", title: "ZTAN Live Group (VIP) — katılım için iletişime geçin" },
  ];
  return (
    <footer className="mt-10 border-t border-bg-border bg-bg-panel" data-testid="app-footer">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img
            src="/brand/logo-square.webp"
            alt="ZTAN Live Group"
            className="h-9 w-9 rounded-md object-cover"
            draggable={false}
          />
          <div>
            <div
              className="text-accent-yellow text-sm font-bold tracking-[0.12em]"
              style={{ fontFamily: "'Orbitron', sans-serif" }}
            >
              ZTAN LIVE GROUP
            </div>
            <div
              className="text-[11px] text-text-secondary"
              style={{ fontFamily: "'Rajdhani', sans-serif" }}
            >
              BIST Teknik Tarama & Piyasa Analiz Terminali · © {new Date().getFullYear()}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              title={s.title || s.label}
              data-testid={s.testId}
              className={`w-9 h-9 rounded-lg border border-bg-border bg-bg-base text-text-secondary flex items-center justify-center transition-colors ${s.hoverCls}`}
              aria-label={s.label}
            >
              <s.Icon size={15} />
            </a>
          ))}
        </div>
      </div>
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 pb-5 -mt-2 space-y-1">
        <p className="text-[10px] text-text-secondary/80 leading-relaxed">
          <span className="text-brand-blueLight">Telegram (Ücretsiz):</span> ZTAN Technical Analyst kanalımıza katılabilirsiniz — <a className="hover:underline" href="https://t.me/ZTANTechnicalAnalyst" target="_blank" rel="noopener noreferrer">t.me/ZTANTechnicalAnalyst</a>
        </p>
        <p className="text-[10px] text-text-secondary/80 leading-relaxed">
          <span className="text-accent-yellow">Telegram VIP:</span> ZTAN Live Group (VIP) grubuna katılım için lütfen X üzerinden iletişime geçin.
        </p>
        <p className="text-[10px] text-text-secondary/60 leading-relaxed pt-1">
          Yatırım tavsiyesi değildir; tüm veriler bilgilendirme amaçlıdır.
        </p>
      </div>
    </footer>
  );
}
